module.exports = __webpack_public_path__ + "root-c2082cbd/XING-Sans-Medium-78d60f26facae4864eb6b20c6bfa7909.woff";